
import * as api from "../../../api"; 
import { appTokenString } from "../../../constants/appInfo";

  
 


export const SendBackAllQuizDataToClient = (post) => async (dispatch)=>{
    try {
           const dataObject={...post,...{appStringSubDomain:appTokenString,osType:'Web'}}
     
        const {data } = await api.SendBackAllQuizDataToClient(dataObject);
       
       
       if(data?.logout){  

          dispatch({type:"LOGOUT"});
        }
        
        
        return data 
     } catch (error) {
       
    }
}


export const SendBackQuizInfoToClient = (post) => async (dispatch)=>{
    try {
           const dataObject={...post,...{appStringSubDomain:appTokenString,osType:'Web'}}
     
        const {data } = await api.SendBackQuizInfoToClient(dataObject);
       
       
       if(data?.logout){  

          dispatch({type:"LOGOUT"});
        }
        
        
        return data 
     } catch (error) {
       
    }
}



export const handleAttemptTestActions = (post) => async (dispatch)=>{
    try {
        const dataObject={...post,...{appStringSubDomain:appTokenString,osType:'Web'}}
       
        const {data } = await api.handleAttemptTestActions(dataObject);
       
        return (data) ;
    } catch (error) {
        console.log(error);
    }
}




